<template>
  <div>
    <b-card>
      <validation-observer ref="vendorFormRef">
        <b-form
          autocomplete="off"
          @submit.prevent="addVendor"
        >
          <b-row>
            <b-col md="6">
              <h5>Vendor Locations</h5>
              <div id="zoneMap" />
            </b-col>
            <b-col md="6">
              <b-row>
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Sequence Prefix"
                    rules="required"
                  >
                    <b-form-group
                      label="Sequence Prefix"
                      label-for="sequence-prefix"
                    >
                      <b-form-input
                        id="sequence-prefix"
                        v-model="vendor.sequencePrefix"
                        :state="errors.length > 0 ? false:null"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Batch Prefix"
                    rules="required"
                  >
                    <b-form-group
                      label="Batch Prefix"
                      label-for="batch-prefix"
                    >
                      <b-form-input
                        id="batch-prefix"
                        v-model="vendor.batchPrefix"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Vendor Name"
                    rules="required"
                  >
                    <b-form-group
                      label="Vendor Name"
                      label-for="vendor-name"
                    >
                      <b-form-input
                        id="vendor-name"
                        v-model="vendor.name"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Vendor Type"
                    rules="required"
                  >
                    <b-form-group
                      label="Vendor Type"
                      label-for="vendor-type"
                    >
                      <b-form-input
                        id="vendor-type"
                        v-model="vendor.vendorType"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Emails"
                    rules="required"
                  >
                    <b-form-group
                      label="Emails"
                      label-for="vendor-emails"
                    >
                      <b-form-input
                        id="vendor-emails"
                        v-model="vendor.emails"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Point Of Contact"
                    rules="required"
                  >
                    <b-form-group
                      label="Point Of Contact"
                      label-for="vendor-point-of-contact"
                    >
                      <b-form-input
                        id="vendor-point-of-contact"
                        v-model="vendor.pointOfContact"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Phone Number"
                    rules="required"
                  >
                    <b-form-group
                      label="Phone Number"
                      label-for="vendor-phone-num"
                    >
                      <b-form-input
                        id="vendor-phone-num"
                        v-model.number="vendor.phoneNumber"
                        type="number"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Max Charge Amount"
                    rules="required"
                  >
                    <b-form-group
                      label="Max Charge Amount"
                      label-for="vendor-max-charge-amount"
                    >
                      <b-form-input
                        id="vendor-max-charge-amount"
                        v-model.number="vendor.maxChargeAmount"
                        type="number"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="4">
                  <b-button
                    variant="success"
                    type="submit"
                    :disabled="submitBtnLoading"
                  >
                    <b-spinner v-if="submitBtnLoading" />
                    <span v-else> Submit</span>
                  </b-button>
                </b-col>
              </b-row>

            </b-col>
          </b-row>
        </b-form>
      </validation-observer>

    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BSpinner,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import useAddVendor from '../hooks/useAddVendor'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import store from '../store'

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BSpinner,
  },
  setup(_, ctx) {
    useRegisterStoreModule('vendors', store)
    return {
      ...useAddVendor(ctx),
      required,
    }
  },
}
</script>

<style scoped>
#zoneMap {
  width: 100%;
  height: 400px;
}
</style>
